<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'App',
  created() {
    localStorage.clear()
    this.$router.push('/login')
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
  @import "common/css/_variate";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  min-height: 100%;
  background-color: #fff;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue